/**
 * Format date string (YYYY-MM-DD or ISO) for display.
 * Parses YYYY-MM-DD as local date to avoid UTC shift (e.g. March 31 becoming March 30 in IST).
 */
export function formatDate(dateString, options = { day: 'numeric', month: 'short', year: 'numeric' }) {
  if (!dateString) return '';
  const str = String(dateString).trim();
  const match = str.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  let date;
  if (match) {
    const [, y, m, d] = match.map(Number);
    date = new Date(y, m - 1, d);
  } else {
    date = new Date(dateString);
  }
  if (isNaN(date.getTime())) return str;
  return date.toLocaleDateString('en-GB', options);
}

/** Short format: 31 Mar 2026 */
export function formatDateShort(dateString) {
  return formatDate(dateString, { day: 'numeric', month: 'short', year: 'numeric' });
}

/** Long format: Tuesday, 31 March 2026 */
export function formatDateLong(dateString) {
  return formatDate(dateString, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
